export const getApiUrl = () => {
    return process.env.NODE_ENV !== 'development' ? process.env.PUBLIC_URL : process.env.REACT_APP_PUBLIC_URL;
}

export const assetUrl = (path) => {
    return getApiUrl() + path;
}
